import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <IndexSection />
        <FeaturesSection />
        <TopicsSection />
        <FaqSection />
        <CardsSection />
        <RankingSection />
        <CommentsSection />
        <AboutSection />
        <UpdatesSection />
        <MediaSection />
        <CarouselSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}